import { useState } from "react";
import { useCart } from "../context/CartContext";
import { colorToCss, shadeColor, isLightColor } from "../utils/colors";
import { imageSrc } from "../utils/assets";
import styles from "./ProductCard.module.css";

export default function ProductCard({ product, discountedPrice, discountPercent }) {
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);
  const [imgError, setImgError] = useState(false);
  const displayPrice = discountedPrice || product.price;

  const base = colorToCss(product.color);
  const panelStyle = { background: `linear-gradient(150deg, ${base} 0%, ${shadeColor(product.color)} 100%)` };
  const light = isLightColor(product.color);
  const showImage = product.image_url && !imgError;

  const handleAdd = () => {
    addToCart(product, displayPrice);
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <div className={styles.card}>
      <div className={`${styles.media} ${light ? styles.mediaLight : ""}`} style={panelStyle}>
        {discountPercent && <div className={styles.discountBadge}>−{discountPercent}%</div>}
        {showImage ? (
          <img
            className={styles.image}
            src={imageSrc(product.image_url)}
            alt={product.name}
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className={styles.panelInner}>
            <span className={styles.emoji}>{product.emoji}</span>
            {product.color && <span className={styles.colorName}>{product.color}</span>}
          </div>
        )}
      </div>

      <div className={styles.body}>
        {product.category_display && (
          <span className={styles.category}>{product.category_display}</span>
        )}
        <h3 className={styles.name}>{product.name}</h3>
        {product.description && <p className={styles.desc}>{product.description}</p>}

        {(product.color || (product.sizes && product.sizes.length > 0)) && (
          <div className={styles.meta}>
            {product.color && (
              <span className={styles.colorTag}>
                <span className={styles.colorDot} style={{ background: colorToCss(product.color) }} />
                {product.color}
              </span>
            )}
            {product.sizes && product.sizes.length > 0 && (
              <span className={styles.sizes}>
                {product.sizes.slice(0, 6).map((s) => (
                  <span key={s} className={styles.sizeChip}>{s}</span>
                ))}
              </span>
            )}
          </div>
        )}

        <div className={styles.footer}>
          {discountedPrice ? (
            <div className={styles.priceRow}>
              <span className={styles.oldPrice}>EGP {product.price.toLocaleString()}</span>
              <span className={styles.price}>EGP {displayPrice.toLocaleString()}</span>
            </div>
          ) : (
            <span className={styles.price}>EGP {displayPrice.toLocaleString()}</span>
          )}

          <button
            className={`${styles.addBtn} ${added ? styles.addBtnDone : ""}`}
            onClick={handleAdd}
          >
            {added ? "Added ✓" : "Add to Bag"}
          </button>
        </div>
      </div>
    </div>
  );
}
